module.exports = __webpack_public_path__ + "img/cate-6-939990.png";